import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=83da0282&scoped=true&"
import script from "./SignUp.vue?vue&type=script&lang=js&"
export * from "./SignUp.vue?vue&type=script&lang=js&"
import style0 from "./SignUp.vue?vue&type=style&index=0&id=83da0282&scoped=true&lang=css&"
import style1 from "@/assets/css/content.css?vue&type=style&index=1&lang=css&"
import style2 from "@/assets/css/font.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83da0282",
  null
  
)

export default component.exports